;(function () {
  'use strict'

  angular
    .module('contrast.rules')
    .constant('RULES_EXPAND_BREAKDOWN_PROPERTIES', [
      'references',
      'customization',
      'app_assess_rules'
    ])
    .constant('PROTECT_RULES_EXPAND_BREAKDOWN_PROPERTIES', [
      'app_protect_rules'
    ])
})()
